import { Navigate, Route } from 'react-router-dom';
import RealEstatePage from 'sites/admin/inmobiliario/gestionarInmobiliaria/RealEstatePage';
import IntegracionPage from 'sites/admin/inmobiliario/integracion/IntegracionPage';
import MercadoLibrePage from 'sites/admin/inmobiliario/mercadoLibre/MercadoLibrePage';
import CallbackML from 'sites/admin/inmobiliario/mercadoLibre/callback/CallbackML';
import { checkToken } from 'utils/checkToken';
import renderConditionalComponent from 'utils/renderConditionalComponent';

const RoutesInmobiliaria = () => {
  const [isAuthenticated, user] = checkToken();
  const isAdmin = user?.typeOfUser === 'admin';

  return (
    <>
      <Route path="/inmobiliaria">
        <Route
          path=""
          element={
            !isAuthenticated ? (
              <Navigate to={'/ingresar'} />
            ) : isAdmin ? (
              <RealEstatePage />
            ) : (
              <Navigate to={'/errors/permisos'} />
            )
          }
        />
      </Route>

      <Route
        path="/integracion"
        element={renderConditionalComponent('Integrations', IntegracionPage)}
      />

      <Route
        path="/ml"
        element={renderConditionalComponent('Mercado Libre', MercadoLibrePage)}
      />

      <Route
        path="callback-ml"
        element={renderConditionalComponent('Mercado Libre', CallbackML)}
      />
    </>
  );
};

export default RoutesInmobiliaria;
